<template>
  <div class="content-wrapper">
    <el-row :gutter="20">
      <el-col :span="4">
        <UserMenu />
      </el-col>
      <el-col :span="20">
        <el-row class="content-title">
          <el-col :span="16">
            <div>收货地址</div>
          </el-col>
          <el-col :span="8" class="text-right">
            <span class="tips">最多可添加5个收货地址</span>
          </el-col>
        </el-row>

        <div class="clearfix">
          <el-card v-for="address in addressList" :key="address.addressId" shadow="hover" class="address-card">
            <!-- <div class="address-name">
              <span>{{ address.shortAddress }}</span>
              <span v-if="address.isDefault === 1"><el-tag :disable-transitions="true" type="success">默认地址</el-tag></span>
            </div> -->
            <el-form :model="address" label-width="80px" class="address-form">
              <el-form-item label="联系人">
                {{ address.contactPerson }}
                <span v-if="address.isDefault === 1"><el-tag :disable-transitions="true" type="success">默认地址</el-tag></span>
              </el-form-item>
              <el-form-item label="联系手机">
                {{ getMaskMobileNo(address.contactMobile) }}
              </el-form-item>
              <el-form-item label="联系电话">
                {{ address.contactPhone }}
              </el-form-item>
              <el-form-item label="收货地址">
                {{ combineAddressInfo(address) }}
              </el-form-item>
            </el-form>
            <div class="address-opt">
              <el-button type="primary" class="btn-yellow" size="mini" icon="el-icon-edit" @click="editAddress(address)">修改</el-button>
              <el-button type="danger" size="mini" icon="el-icon-delete" @click="removeAddress(address)">删除</el-button>
            </div>
          </el-card>
        </div>


        <div class="address-add">
          <el-button class="btn-red button-add" icon="el-icon-plus" @click="addAddress()">添加地址</el-button>
        </div>
      </el-col>
    </el-row>

    <AddressForm ref="address-form" @success="onAddressSubmit" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import userApi from '@/api/user'
import { commonUtils } from '@/utils/common'
import UserMenu from './components/user-menu'
import AddressForm from './components/address-form'
export default {
  name: 'UserAddress',
  components: {
    UserMenu,
    AddressForm
  },
  data() {
    return {
      addressList: [],
      loading: false
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'isDealerClient'
    ])
  },
  mounted() {
    this.getAddressList()
  },
  methods: {
    getAddressList() {
      this.loading = true
      userApi.queryAdddressList().then(response => {
        this.loading = false
        this.addressList = response.data.resultData.addressList
      }).catch(() => {
        this.loading = false
      })
    },
    getMaskMobileNo(mobile) {
      return commonUtils.maskMobileNo(mobile)
    },
    combineAddressInfo(row) {
      let showInfo = ''
      showInfo += row.provinceName ? row.provinceName : ''
      showInfo += row.cityName ? (', ' + row.cityName) : ''
      showInfo += row.countyName ? (', ' + row.countyName) : ''
      showInfo += row.detailAddress ? (', ' + row.detailAddress) : ''
      return showInfo
    },
    addAddress() {
      const addressForm = { action: 'create' }
      this.$refs['address-form'].show(addressForm)
    },
    editAddress(address) {
      const addressForm = Object.assign({ action: 'update' }, address)
      this.$refs['address-form'].show(addressForm)
    },
    onAddressSubmit() {
      this.getAddressList()
    },
    removeAddress(address) {
      this.$confirm('是否删除收货地址?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        userApi.removeAddress(address).then(response => {
          if (response.data.resultCode === '0') {
            this.getAddressList()
            this.$message.success('收货地址删除成功')
          }
        })
      }).catch(() => {
        console.log('cancel opt')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';
.tips {
  font-size: 12px;
  color: blue;
  margin-top: 20px;
}
.address-card {
  float: left;
  width: 450px;
  height: 220px;
  margin: 0 20px 20px 0;
  font-size: 12px;
  /deep/ .el-card__body {
    padding: 10px 0;
  }
  .address-name {
    padding: 0 30px;
    border-bottom: 1px solid #cccccc;
    background-color: #eee;
    font-weight: 700;
    height: 36px;
    line-height: 36px;
  }
  .el-tag--success {
    background-color: rgba(18,206,102,.1);
    border-color: rgba(18,206,102,.2);
    color: #13ce66;
    padding: 0 15px;
    height: 24px;
    line-height: 22px;
    font-weight: norma;
    margin-left: 20px;
  }
  .address-form {
    height: 160px;
    overflow: hidden;
    .el-form-item {
      margin-bottom: 5px;
    }
    /deep/ .el-form-item__label, /deep/ .el-form-item__content {
      font-size: 12px;
      line-height: 24px;
    }
  }
  .address-opt {
    height: 36px;
    padding: 5px 10px;
    text-align: center;
  }
}

.address-add {
  height: 40px;
  margin: 10px;
  text-align: center;
}

</style>
